module.exports = __webpack_public_path__ + "img/直播评分管理.53e97a44.png";